import {LexicalNode, type DOMExportOutputMap} from 'lexical';
import {
  BeautifulMentionsItem,
  BeautifulMentionsMenuItemProps,
  createBeautifulMentionNode,
} from 'lexical-beautiful-mentions';
import {Integer} from 'platform/foundation';

import {ElementType} from 'react';

import {TestIdProps} from 'shared/web';

import {FormControlProps} from '../../../types/FormControlProps';
import {ContentEditableProps} from '../components/StyledContentEditable';

export interface SuggestionInputProps
  extends FormControlProps<string | null, HTMLTextAreaElement>,
    TestIdProps {
  placeholder?: string;
  menuItem?: ElementType<BeautifulMentionsMenuItemProps>;
  ContentEditableComponent?: ElementType<ContentEditableProps>;
  minHeight?: Integer;
  MenuItemComponent?: ElementType<BeautifulMentionsMenuItemProps>;
  CustomMention?: ReturnType<typeof createBeautifulMentionNode>;
  exportHtmlNodeTransforms?: (nodes: DOMExportOutputMap) => DOMExportOutputMap;
  transformStringToNodes: (value: string | null) => LexicalNode[];
  prefix: string;
  options: BeautifulMentionsItem[];
  isLoadingOptions?: boolean;
}
